import type { MailboxDto, MailDomainDto, MailForwarderDto } from './mail.js';
import type { SftpUserDto, SubscriptionFileAccessDto } from './files.js';

export const MAIL_MANAGE_FEATURE = 'mail_manage_accounts';
export const MAIL_DOMAIN_MANAGE_FEATURE = 'mail_manage_domains';
export const FILES_MANAGE_FEATURE = 'files_manage_accounts';
export type CustomerMailboxDto = Omit<MailboxDto, 'stalwartId'>;
export type CustomerMailForwarderDto = Omit<MailForwarderDto, 'stalwartId'>;
export type CustomerMailDomainSummaryDto = Omit<MailDomainDto, 'stalwartId' | 'subscriptionId' | 'dnsPublicationEnabled'> & {
  publicationStatus?: 'provider-review' | 'enabled';
  setupStatus?: 'ready' | 'needs-attention';
  canRemove?: boolean;
};
export type CustomerMailDomainDto = CustomerMailDomainSummaryDto & {
  mailboxes: CustomerMailboxDto[];
  forwarders: CustomerMailForwarderDto[];
};
export interface CustomerMailDto { canManageDomains?: boolean; availableDomains?: string[]; canManagePreferences?: boolean; subscriptionId: string; featureEnabled: boolean; configured: boolean; domains: CustomerMailDomainDto[]; }
export type CustomerFileUserDto = Omit<SftpUserDto, 'serverUuid' | 'homeDir' | 'lastError' | 'folders'> & {
  folders: Pick<SftpUserDto['folders'][number], 'resourceId' | 'resourceName' | 'volumeName' | 'virtualPath' | 'relativePath' | 'mode'>[];
};
export type CustomerFileAccessDto = Omit<SubscriptionFileAccessDto, 'users' | 'user' | 'availableFolders'> & {
  users: CustomerFileUserDto[];
  user: CustomerFileUserDto | null;
  /** volumeName is an opaque selection token on the customer API. */
  availableFolders: (SubscriptionFileAccessDto['availableFolders'][number] & { label: string })[];
};


export const DATABASES_MANAGE_FEATURE = 'databases_manage';
export const APPLICATION_TASKS_MANAGE_FEATURE = 'applications_manage_tasks';
export interface CustomerDatabasePolicyDto {
  serverUuid: string;
  engines: import('./databases.js').DatabaseEngine[];
}
export interface CustomerDatabaseOptionsDto {
  configured: boolean;
  engines: import('./databases.js').DatabaseEngine[];
}
export interface CustomerDatabaseDetailDto {
  id: string;
  name: string;
  status: string;
  linked: boolean;
  image: string | null;
  isPublic: boolean;
  publicPort: number | null;
  deploymentsEnabled: boolean;
  externalAccessEnabled: boolean;
  liveError: string | null;
}
export interface CustomerDatabaseCreatedDto {
  database: { id: string; name: string; status: string };
  credentials: import('./databases.js').DatabaseCredentialsDto;
  warning: string | null;
}


export const APPLICATION_RUNTIME_MANAGE_FEATURE = 'applications_manage_runtime';
export const APPLICATION_DOMAINS_MANAGE_FEATURE = 'applications_manage_domains';
export const MONITORING_MANAGE_FEATURE = 'monitoring_manage_checks';
export interface CustomerApplicationDto {
  id: string;
  name: string;
  linked: boolean;
  liveError: string | null;
  domainChangePending: boolean;
  gitManaged: boolean;
  zones: string[];
  domains: string[];
  canManageDomains: boolean;
  canManageRuntime: boolean;
  canManageHealth: boolean;
  canManageMaintenance: boolean;
  portsExposes: string;
  installCommand: string;
  buildCommand: string;
  startCommand: string;
  healthCheck: import('./applications.js').CoolifyApplicationDto['healthCheck'] | null;
}
